/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./FormFieldEmail.vue?vue&type=template&id=20fb63cf"
import script from "./FormFieldEmail.vue?vue&type=script&lang=js"
export * from "./FormFieldEmail.vue?vue&type=script&lang=js"
import style0 from "./FormFieldEmail.vue?vue&type=style&index=0&id=20fb63cf&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* custom blocks */
import block0 from "./FormFieldEmail.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports